"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _readingsToCoordinates = require("../../transformers/readingsToCoordinates");

var _chartUtils = require("../../chartUtils");

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

require("react-vis/dist/style.css");

var _DailyChart = _interopRequireDefault(require("./DailyChart"));

var _hooks = require("../../hooks");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable no-restricted-globals */
var transformMaxPercentageCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('maxBatteryPercentageState')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'maxBatteryPercentageState'));
});
var transformMinPercentageCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('minBatteryPercentageState')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'minBatteryPercentageState'));
});
var transformAreaPercentageCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  var isValidMaxReading = (0, _chartUtils.isValidReading)('maxBatteryPercentageState');
  var isValidMinReading = (0, _chartUtils.isValidReading)('minBatteryPercentageState');
  return readings.filter(function (r) {
    return isValidMaxReading(r) && isValidMinReading(r);
  }).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'maxBatteryPercentageState', 'minBatteryPercentageState'));
});
var transformToBatterybatteryChargeCoordinates = (0, _memoizeOne["default"])(function (batteryReadings, timeZone) {
  return batteryReadings.filter((0, _chartUtils.isValidReading)('batteryCharge')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'batteryCharge'));
});
var transformToBatterybatteryDischargeCoordinates = (0, _memoizeOne["default"])(function (batteryReadings, timeZone) {
  return batteryReadings.filter((0, _chartUtils.isValidReading)('batteryDischarge')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'batteryDischarge'));
});
var transformToConsumptionCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('consumption')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'consumption'));
});
var transformToContractCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('contract')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'contract'));
});
var transformToEstimatedSolarCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('estimatedSolar')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'estimatedSolar'));
});
var transformToExportCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('exportReading')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'exportReading'));
});
var transformToImportCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('importReading')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'importReading'));
});
var transformToPeerAdjCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('peer')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'peer'));
});
var transformToPeerCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('peer')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'peer'));
});
var transformToSelfConsumptionCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('selfConsumption')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'selfConsumption'));
});
var transformToSolarCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone, fieldName) {
  return productionReadings.filter((0, _chartUtils.isValidReading)(fieldName)).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, fieldName));
});
var transformToSystemProductionCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('systemProduction')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'systemProduction'));
});

var getSolar = function getSolar(readings, timeZone, hasBattery, isHiBBSystem) {
  return isHiBBSystem ? transformToSystemProductionCoordinates(readings, timeZone) : transformToSolarCoordinates(readings, timeZone, hasBattery ? 'batterySolar' : 'pvSolar');
};

var DailyChartContainer = function DailyChartContainer(_ref) {
  var activeDataValues = _ref.activeDataValues,
      authToken = _ref.authToken,
      baseUrl = _ref.baseUrl,
      hasBattery = _ref.hasBattery,
      hasCT = _ref.hasCT,
      internalUsage = _ref.internalUsage,
      prospectId = _ref.prospectId,
      storageProfile = _ref.storageProfile,
      timeZone = _ref.timeZone,
      viewEndISO = _ref.viewEndISO,
      viewStartISO = _ref.viewStartISO,
      withBatteryChart = _ref.withBatteryChart;

  var viewStartDateTime = _luxon.DateTime.fromISO(viewStartISO, {
    zone: timeZone
  });

  var viewEndDateTime = _luxon.DateTime.fromISO(viewEndISO, {
    zone: timeZone
  });

  var startMillis = viewStartDateTime.toMillis();
  var endMillis = viewEndDateTime.toMillis();
  var siteProductionReadings = (0, _hooks.useDailyPerformance)(prospectId, viewStartISO, viewEndISO, baseUrl, authToken) || [];
  var siteBatteryReadings = (0, _hooks.useBatteryDailyAverage)(prospectId, viewStartISO, viewEndISO, baseUrl, authToken, hasBattery) || {};
  var aggBatteryPerformanceReadings = (siteBatteryReadings === null || siteBatteryReadings === void 0 ? void 0 : siteBatteryReadings.performanceData) || [];
  var contractReadings = (0, _hooks.useContractGenDaily)(prospectId, viewStartISO, viewEndISO, baseUrl, authToken, internalUsage) || [];
  var peerReadings = (0, _hooks.usePeerDaily)(prospectId, viewStartISO, viewEndISO, baseUrl, authToken, internalUsage) || [];
  var peerV2Readings = (0, _hooks.usePeerDailyV2)(prospectId, viewStartISO, viewEndISO, baseUrl, authToken, internalUsage) || [];
  var isBatteryLoading = (0, _hooks.useBatteryDailyLoading)();
  var isProductionLoading = (0, _hooks.useDailyPerformanceLoading)();
  var isContractLoading = (0, _hooks.useContractGenDailyLoading)();
  var isPeerLoading = (0, _hooks.usePeerDailyLoading)();
  var isPeerV2Loading = (0, _hooks.usePeerDailyV2Loading)();
  var isLoading = isBatteryLoading || isProductionLoading || isContractLoading || isPeerLoading || isPeerV2Loading; // NOTE: checking for HI systems is temporary. Solar calculation is being improved.

  var isHiBBSystem = hasBattery && timeZone === 'Pacific/Honolulu';
  var batteryChargeCoordinates = hasBattery && activeDataValues.includes('charge') ? transformToBatterybatteryChargeCoordinates(aggBatteryPerformanceReadings, timeZone) : [];
  var batteryDischargeCoordinates = hasBattery && activeDataValues.includes('discharge') ? transformToBatterybatteryDischargeCoordinates(aggBatteryPerformanceReadings, timeZone) : [];
  var consumptionCoordinates = hasCT && activeDataValues.includes('consumption') ? transformToConsumptionCoordinates(siteProductionReadings, timeZone) : [];
  var contractCoordinates = activeDataValues.includes('contract') ? transformToContractCoordinates(contractReadings, timeZone) : [];
  var exportCoordinates = hasCT && activeDataValues.includes('export') ? transformToExportCoordinates(siteProductionReadings, timeZone) : [];
  var importCoordinates = hasCT && activeDataValues.includes('import') ? transformToImportCoordinates(siteProductionReadings, timeZone) : [];
  var systemProductionCoordinates = hasBattery && activeDataValues.includes('systemProduction') ? transformToSystemProductionCoordinates(siteProductionReadings, timeZone) : [];
  var peerCoordinates = activeDataValues.includes('peer') ? transformToPeerAdjCoordinates(peerReadings, timeZone) : [];
  var peerV2Coordinates = activeDataValues.includes('peerV2') ? transformToPeerCoordinates(peerV2Readings, timeZone) : [];
  var selfConsumptionCoordinates = hasCT && activeDataValues.includes('selfConsumption') ? transformToSelfConsumptionCoordinates(siteProductionReadings, timeZone) : [];
  var solarCoordinates = activeDataValues.includes('solar') ? getSolar(siteProductionReadings, timeZone, hasBattery, isHiBBSystem) : [];
  var estimatedSolarCoordinates = hasBattery || !activeDataValues.includes('solar') || !internalUsage ? [] : transformToEstimatedSolarCoordinates(siteProductionReadings, timeZone);
  var maxBatteryCoordinates = transformMaxPercentageCoordinates(aggBatteryPerformanceReadings, timeZone);
  var minBatteryCoordinates = transformMinPercentageCoordinates(aggBatteryPerformanceReadings, timeZone);
  var areaBatteryCoordinates = transformAreaPercentageCoordinates(aggBatteryPerformanceReadings, timeZone);
  var displayCoordinates = {
    batteryChargeCoordinates: batteryChargeCoordinates,
    batteryDischargeCoordinates: batteryDischargeCoordinates,
    consumptionCoordinates: consumptionCoordinates,
    contractCoordinates: contractCoordinates,
    estimatedSolarCoordinates: estimatedSolarCoordinates,
    exportCoordinates: exportCoordinates,
    importCoordinates: importCoordinates,
    peerCoordinates: peerCoordinates,
    peerV2Coordinates: peerV2Coordinates,
    selfConsumptionCoordinates: selfConsumptionCoordinates,
    solarCoordinates: solarCoordinates,
    systemProductionCoordinates: systemProductionCoordinates
  };
  var coordinatesGroupedByTime = (0, _RecentPerformanceCrosshair.groupCoordinatesByTime)({
    charge: batteryChargeCoordinates,
    consumption: consumptionCoordinates,
    contract: contractCoordinates,
    discharge: batteryDischargeCoordinates,
    estimatedSolar: estimatedSolarCoordinates,
    exportValue: exportCoordinates,
    importValue: importCoordinates,
    maxBattery: maxBatteryCoordinates,
    minBattery: minBatteryCoordinates,
    peer: peerCoordinates,
    peerV2: peerV2Coordinates,
    selfConsumption: selfConsumptionCoordinates,
    solar: solarCoordinates,
    systemProduction: systemProductionCoordinates
  });
  var batteryCoordinates = {
    areaCoordinates: areaBatteryCoordinates,
    maxCoordinates: maxBatteryCoordinates,
    minCoordinates: minBatteryCoordinates
  };
  return /*#__PURE__*/_react["default"].createElement(_DailyChart["default"], {
    batteryCoordinates: batteryCoordinates,
    coordinatesGroupedByTime: coordinatesGroupedByTime,
    displayCoordinates: displayCoordinates,
    endMillis: endMillis,
    hasBattery: hasBattery,
    hasConsumption: hasCT,
    internalUsage: internalUsage,
    isLoading: isLoading,
    key: "".concat(startMillis).concat(endMillis),
    startMillis: startMillis,
    storageProfile: storageProfile,
    timeZone: timeZone,
    viewEndISO: viewEndISO,
    viewStartISO: viewStartISO,
    withBatteryChart: withBatteryChart
  });
};

DailyChartContainer.propTypes = {
  activeDataValues: _propTypes["default"].arrayOf(_propTypes["default"].string),
  authToken: _propTypes["default"].string.isRequired,
  baseUrl: _propTypes["default"].string.isRequired,
  hasBattery: _propTypes["default"].bool,
  hasCT: _propTypes["default"].bool,
  internalUsage: _propTypes["default"].bool,
  prospectId: _propTypes["default"].string.isRequired,
  storageProfile: _propTypes["default"].shape({
    storageMode: _propTypes["default"].string,
    storageProfileDetails: _propTypes["default"].shape({
      name: _propTypes["default"].string
    })
  }),
  timeZone: _propTypes["default"].string,
  viewEndISO: _propTypes["default"].string.isRequired,
  viewStartISO: _propTypes["default"].string.isRequired,
  withBatteryChart: _propTypes["default"].bool
};
DailyChartContainer.defaultProps = {
  activeDataValues: ['solar', 'systemProduction', 'consumption', 'selfConsumption', 'peerV2', 'contract', 'export'],
  hasBattery: false,
  hasCT: false,
  internalUsage: false,
  storageProfile: {},
  timeZone: 'local',
  withBatteryChart: false
};
var _default = DailyChartContainer;
exports["default"] = _default;